import Auth from '@/service/auth.js';

let cache = null;
let inflight = null;

export default {
    /**
     * Retorna o usuario autenticado (cacheado apos primeira chamada).
     * Nunca rejeita — em caso de erro resolve para null.
     */
    get() {
        if (cache) return Promise.resolve(cache);
        if (inflight) return inflight;

        inflight = Auth.me()
            .then(res => {
                cache = res?.data ?? null;
                return cache;
            })
            .catch(() => null)
            .finally(() => { inflight = null; });

        return inflight;
    },

    /**
     * Permite ao AppLayout popular o cache com o usuario ja buscado,
     * evitando request duplicado em /api/auth.
     */
    set(user) {
        cache = user || null;
    },

    /**
     * Retorna o projeto_default_id do usuario ou null. Nunca rejeita.
     */
    projetoDefaultId() {
        return this.get().then(u => u?.projeto_default_id ?? null).catch(() => null);
    },

    /**
     * Invalida o cache (usar em logout ou troca de usuario).
     */
    clear() {
        cache = null;
        inflight = null;
    },
};
